import { render } from "./applePay.vue?vue&type=template&id=ed0a9f2e&bindings={\"navigate\":\"props\"}"
import script from "./applePay.vue?vue&type=script&lang=js"
export * from "./applePay.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./applePay.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script